import Header from '../../components/reusable/Header';
import BackButton from '../../components/reusable/buttons/BackButton';
import PageTitle from '../../components/reusable/PageTitle';

const PrivacyAndSecurity = () => {
    const PrivacyLinks = [
        {
            title: 'TERMS AND CONDITIONS',
            linkPath: 'https://join.playerapp.co/tcs'
        },
        {
            title: 'PRIVACY POLICY',
            linkPath: 'https://join.playerapp.co/privacypolicy'
        }
    ];

    const openUrl = url => {
        if (!url) return;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className='page md:max-w-[700px] mx-auto flex flex-col min-h-screen'>
            <Header>
                <BackButton from='' />
            </Header>

            <PageTitle>
                <div className='text-[20px] uppercase'>
                    PRIVACY AND SECURITY
                </div>
            </PageTitle>
            <div className='mt-[65px] flex-grow'>
                {PrivacyLinks.map(({ linkPath, title }, i) => (
                    <div
                        onClick={() => openUrl(linkPath)}
                        key={i}
                        className='flex justify-between items-center py-[20px] cursor-pointer'
                    >
                        <p className='uppercase text-[15px] font-favela-bold font-bold'>
                            {title}
                        </p>
                        <img src='/images/url-link.svg' alt='' />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PrivacyAndSecurity;
